export const getChartAnalysesState = state => state.chartAnalyses;
export const getChartAnalysesList = state => state.chartAnalyses.list;
